import React from 'react';
import { styled } from '@mui/material/styles';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import Link from 'next/link';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Grid from '@mui/material/Grid';
import { count, getCategoryVisibleSons } from '@components/config/helpers';
import useCategoryShallowLink from '@components/_hooks/CSRHooks/useCategoryShallowLink';
import { useSelector } from 'react-redux';


const AccordionSummary = styled((props) => <MuiAccordionSummary {...props} />)(({ theme }) => ({
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, .05)'
        : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      transform: 'rotate(360deg)',
    },
    '& .MuiAccordionSummary-content': {
      marginLeft: theme.spacing(1),
    },
    // '& .MuiAccordionSummary-content': {
    //   marginLeft: theme.spacing(1),
    // },
}));

const CategoryName = ({ route, check, idx, category, expanded, children }) => {
    const {handleShallowLink} = useCategoryShallowLink();
    const {pageSpinner} = useSelector((state) => state.globalReducer);
    const {categoryLoaders} = useSelector((state) => state.categoryReducer);
    return (
        <Link shallow={true} onClick={(e) =>{
            handleShallowLink(e, category.slug, category?.static)
        }
         } scroll={false} className="w-100" href={`/${category.slug}`} style={{ textDecoration: 'none' }}>
            <AccordionSummary
                disabled={pageSpinner || categoryLoaders.fetchingCategory}
                className="pl-0 ml-0"
                aria-controls={`${route}-content`} 
                expandIcon={
                    count(getCategoryVisibleSons(category)) > 0 ? (
                        expanded == idx ? (
                            <ExpandLessIcon 
                                sx={{
                                    color: 'primary.main'
                                }}  
                            /> 
                        ) : (
                            <ExpandMoreIcon 
                                sx={{
                                    color: route === [check]?.name && '000'
                                }}  
                            /> 
                        )
                    ) : null
                }
                sx={{
                    backgroundColor: (typeof route != 'undefined' && route === category?.sons?.[check]?.name) || expanded == idx ? '#ebe9e9' : 'white.main',
                    ":hover": { 
                        backgroundColor: '#F5F5F5', 
                        color:  'primary.main'
                    },
                    '& .MuiAccordionSummary-content': {
                        marginLeft: 0,
                        paddingLeft: 1
                    }
                }}
            >
                <Grid container className='MuiAccordionSummary-root t' sx={{padding:0}}>
                    <Grid item xs={12}>
                        <Box className='d-flex MuiAccordionSummary-content' sx={{width:'100%', }}>
                            <Typography color={route == category.name || expanded == idx ? 'primary' : 'default'} className='w-100'>
                                {category.name}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </AccordionSummary>
        </Link>
    );
};

export default CategoryName;